export const initialState = {
    stats:'',
    claimsLoading:false,
    loading: false,
    claims: [],
    totalClaimsCount:0
};
